import { FC } from "react";

export const ChartIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.72502 17.7502C2.50836 17.5335 2.40002 17.2835 2.40002 17.0002C2.40002 16.7169 2.50836 16.4669 2.72502 16.2502L8.77502 10.2002C8.97502 10.0002 9.20836 9.9002 9.47502 9.9002C9.74169 9.9002 9.97502 10.0002 10.175 10.2002L13.475 13.5002L19.875 6.2752C20.0584 6.05853 20.296 5.9502 20.588 5.9502C20.8794 5.9502 21.125 6.0502 21.325 6.2502C21.5084 6.43353 21.6044 6.6542 21.613 6.9122C21.621 7.17086 21.5334 7.4002 21.35 7.6002L14.175 15.7002C13.9917 15.9169 13.7544 16.0295 13.463 16.0382C13.171 16.0462 12.925 15.9502 12.725 15.7502L9.47502 12.5002L4.22502 17.7502C4.00836 17.9669 3.75836 18.0752 3.47502 18.0752C3.19169 18.0752 2.94169 17.9669 2.72502 17.7502Z"
      fill="currentColor"
    />
  </svg>
);
